/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_G1_TInputs */

const en_mk_sec_pg_g1_t = /** @type {(inputs: Mk_Sec_Pg_G1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tool allowlist`)
};

const id_mk_sec_pg_g1_t = /** @type {(inputs: Mk_Sec_Pg_G1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar alat yang diizinkan`)
};

/**
* | output |
* | --- |
* | "A tool allowlist" |
*
* @param {Mk_Sec_Pg_G1_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_g1_t = /** @type {((inputs?: Mk_Sec_Pg_G1_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_G1_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_g1_t(inputs)
	return en_mk_sec_pg_g1_t(inputs)
});